import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query';
import { ApiError } from 'shared/api/client.js';

// Security-hardening task, item 2: middleware/sessionExpiry.js can 401 ANY
// authenticated request mid-session (idle timeout hit maxAge, or the
// absolute-expiry check fired), not just GET /auth/me. Without this, a page
// already open with fetched data would show a bare inline error on whatever
// query happened to hit the expiry first, while the rest of the UI kept
// rendering as if still logged in. Centralized here (once, for every
// query/mutation) rather than in each component: catching SESSION_EXPIRED
// clears the cached `auth.me` user, which App.jsx's RequireRole reads to
// redirect to /login — the same mechanism a real logout already uses.
function handleQueryError(err) {
  if (err instanceof ApiError && err.code === 'SESSION_EXPIRED') {
    queryClient.setQueryData(['auth', 'me'], null);
  }
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
  queryCache: new QueryCache({ onError: handleQueryError }),
  mutationCache: new MutationCache({ onError: handleQueryError }),
});
